import { Link, NavLink } from "react-router-dom";

function Header() {
  return (
    <>
      <nav className="navbar navbar-expand-lg px-0 py-1 mb-1 sticky-top">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img
              src="/assets/images/fndrma-logo.png"
              width="200"
              alt=""
              className="d-lg-block d-none"
            />
            <img
              src="/assets/images/fndrma-logo.png"
              width="150"
              alt=""
              className="d-lg-none d-block"
            />
          </Link>
          <div className="ms-auto d-flex align-items-center order-lg-3">
            <div class="d-flex">
              <Link
                to="/contact"
                class="btn btn-outline-dark rounded-3 px-5 me-2 d-none d-md-block"
              >
                Contact Us
              </Link>
              <Link
                to="/login"
                state={{
                  role: "investor",
                }}
                class="btn btn-primary px-5 rounded-3"
              >
                Get Started
              </Link>
            </div>
          </div>
          <div>
            <button
              className="navbar-toggler collapsed ms-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-default"
              aria-controls="navbar-default"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-bar top-bar mt-0" />
              <span className="icon-bar middle-bar" />
              <span className="icon-bar bottom-bar" />
            </button>
          </div>
          <div className="collapse navbar-collapse ps-lg-5" id="navbar-default">
            <ul className="navbar-nav mt-3 mt-lg-0">
              <li className="nav-item">
                <NavLink to="/" className="nav-link">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/about" className="nav-link">
                  About Us
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/investor" className="nav-link">
                  Investor
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/filmmaker" className="nav-link">
                  Filmmaker
                </NavLink>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">
                  Career
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
